import { PANELS } from './panelRoutes';

export function panelUrl(panel) {
  if (!panel) return null;
  const path = panel.focus?.path || PANELS.find(p => p.label === panel.tab)?.path;
  if (!path) return null;
  const query = new URLSearchParams();
  for (const key of ['q', 'where', 'remote', 'job', 'section', 'entry', 'open', 'version', 'seniority', 'postedWithin', 'resume']) {
    const value = panel.focus?.[key];
    for (const item of (Array.isArray(value) ? value : [value])) {
      if (item !== undefined && item !== null && item !== '') query.append(key, String(item));
    }
  }
  return path + (query.toString() ? `?${query}` : '');
}

// Count-only results never spend the first move. A click locks the whole turn,
// even if the person picked the tab that was already open.
export function followPanel(turn, panel, kind, { phone = false } = {}) {
  if (!panel || !panelUrl(panel)) return { turn, move: false, count: false };
  const move = !phone && !turn.clicked && !panel.focus?.countOnly
    && (!turn.moved || ['proposal', 'change', 'final'].includes(kind));
  return { turn: { ...turn, moved: turn.moved || move }, move, count: !move };
}
export const lastPanel = (tools = []) => [...tools].reverse().find(t => t.panel && !t.panel.focus?.countOnly)?.panel;

// The applications a conversation started (queue_job), each under the reply
// that last started it: reply id → job ids. That reply asks what only the
// person can answer for them (AskOnce.js). A failed or refused call has no
// panel, so it started nothing.
export function startedBy(messages = []) {
  const last = new Map();
  for (const m of messages) {
    for (const t of m.tools || []) {
      const job = t.name === 'queue_job' ? t.panel?.focus?.job : null;
      if (job) last.set(String(job), m.id);
    }
  }
  const by = new Map();
  for (const [job, id] of last) by.set(id, [...(by.get(id) || []), job]);
  return by;
}
